export function openProductDialog(productID){

    if(document.getElementById('dialog-'+productID)){

        let dialog = document.getElementById('dialog-'+productID)
        
        dialog.showModal();

    }

}